var React = require('react');

function Eth (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#627EEA","key":0}),React.createElement("g",{"fill":"#FFF","fillRule":"nonzero","key":1},[React.createElement("path",{"fillOpacity":".602","d":"M16.498 4v8.87l7.497 3.35z","key":0}),React.createElement("path",{"d":"M16.498 4L9 16.22l7.498-3.35z","key":1}),React.createElement("path",{"fillOpacity":".602","d":"M16.498 21.968v6.027L24 17.616z","key":2}),React.createElement("path",{"d":"M16.498 27.995v-6.028L9 17.616z","key":3}),React.createElement("path",{"fillOpacity":".2","d":"M16.498 20.573l7.497-4.353-7.497-3.348z","key":4}),React.createElement("path",{"fillOpacity":".602","d":"M9 16.22l7.498 4.353v-7.701z","key":5})])]));
}

Eth.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Eth;

Eth.default = Eth;
